import React, { useState } from "react";
import axios from "axios";
import { API_KEY, API_URL } from "../constants/api";
import { WEATHER_DATA_LOADED } from "../constants/actionTypes";
import SearchForm from "./SearchForm";
import WeatherNow from "./WeatherNow";
import Forecast from "./Forecast";
import { SearchContextProvider } from "../context/SearchContext";
import { UnitProvider } from "../context/UnitContext";
import {
  useWeatherDataDispatch,
  useWeatherData,
} from "../context/WeatherDataContext";
import BusyIndicator from "./BusyIndicator";
import { METRIC } from "../constants/units";
import { useDefaultCity } from "../context/DefaultCityContext";

import "../../css/Weather.css";

export default function Weather() {
  const dispatch = useWeatherDataDispatch();
  const weatherData = useWeatherData();
  const defaultCity = useDefaultCity();
  const [hasError, setHasError] = useState(null);

  const handleResponse = ({
    coord,
    main: { temp, humidity },
    dt,
    weather,
    wind: { speed },
    name,
  }) => {
    const { icon, description } = weather[0];

    dispatch({
      type: WEATHER_DATA_LOADED,
      data: {
        loaded: true,
        coordinates: coord,
        temperature: temp,
        humidity,
        date: new Date(dt * 1000),
        description,
        icon,
        wind: speed,
        city: name,
      },
    });
  };

  const search = async (location, unit) => {
    let url = `${API_URL}weather?q=${location}&appid=${API_KEY}&units=${unit}`;

    try {
      const response = await axios.get(url);

      handleResponse(response.data);
      hasError && setHasError(false);
    } catch (error) {
      console.error("There is no such destination.");
      setHasError(true);
    }
  };

  if (!weatherData.loaded) {
    search(defaultCity, METRIC);

    return (
      <div className="w-100 text-center">
        <BusyIndicator />
      </div>
    );
  }

  return (
    <div className="Weather">
      <UnitProvider>
        <SearchContextProvider search={search}>
          <SearchForm
            isInvalid={hasError}
            handleClearValidationError={() => setHasError(false)}
          />
          <WeatherNow />
        </SearchContextProvider>
        <Forecast coordinates={weatherData.coordinates} />
      </UnitProvider>
    </div>
  );
}
